<ng-template
  #starsTemplate
  let-fill="fill"
>
  <span
    class="star"
    [ngClass]="{ 'is-invalid': isInvalid }"
    [class.full]="fill === 100"
  >
    <i
      class="fa-fw"
      [classList]="starIconClasses"
      [ngClass]="fill > 49 ? 'fas fa-star' : 'far fa-star'"
    ></i>
  </span>
</ng-template>

<div class="d-flex justify-content-start align-items-center">
  <ngb-rating
    *ngIf="formControl; else staticRating"
    [starTemplate]="starsTemplate"
    [max]="5"
    [formControl]="formControl"
  ></ngb-rating>
  <ng-template #staticRating>
    <ngb-rating
      [rate]="currentRate ?? 0"
      (rateChange)="currentRate = $event"
      [starTemplate]="starsTemplate"
      [readonly]="true"
      [max]="5"
    ></ngb-rating>
  </ng-template>
  <span
    class="review-count"
    *ngIf="!hideCount"
    >({{ reviewCount }} {{ (reviewCount === 1 ? 'review' : 'reviews') | translate }})</span
  >
</div>

<p *ngIf="isInvalid && errorMessage">
  {{ errorMessage | translate }}
</p>
